import React, { useState, useRef } from 'react';
import { useCoverLetter } from '../../../context/CoverLetterContext';
import { TPLTS, } from '../../../constants/constants';
import ListTemplate from '../ListTemplate';
import StyleOptions from './StyleOptions';
const DesignControl = (props) => {
  const ddRef = useRef();
  //Show error using this state
  const [error, setError] = useState({});
  const [selectedCustomColor, setSelectedCustomColor] = useState('');
  const {
    active_template,
    custom_template_color
  } = useCoverLetter();

  return (
    <div className="panel-left panel-left-customization">
      <div className="screen-action">
        <button className="round-btn" 
            onClick={() => {
            // setNext(!next)
            props.setStylePanel(false)
            }}>
          <i className="icon-cross-icon"></i><span>Close</span>
          </button>
          <button className="round-btn active" 
            onClick={() => {
              props.setStylePanel(false)
            }}> 
            {/* <i className="arrow-bar-left"></i> */}
            <span>Done</span>
          </button>
        </div>
      <StyleOptions setSelectedCustomColor={setSelectedCustomColor} />
      <div className="cover-template-cards">
        <div className="cover-cards">
          <ListTemplate
            templates={TPLTS
            .filter(t => t.hasOwnProperty('coverletter') && t.coverletter)
            .sort((a, b) => (b?.coverletter_listing_priority - a.coverletter_listing_priority))}
            active_template={active_template}
            //color={color}
            customColor={selectedCustomColor}
            // headerColor={''}
            // page={"choose-template"}
            // rows={2}
            // singleResume={singleResume}
            setSingleResume={(e) => {
              getStaticTemplate(e);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default DesignControl;